import { createModuleStrings } from '@platform/core/lib/moduleStrings';
import type { IModuleSummary, Lang } from '@platform/core/types';
import { moduleBundle } from '@platform/i18n';

/**
 * Опис модуля мовою інтерфейсу, як desc модуля прототипу v4 (той самий текст, що й підзаголовок сторінки модуля): опис головного типу
 * запису з пакета модуля, без нього — гасло модуля з каталогу. Пакет ще не завантажено — гасло. Чиста функція (читає сховище i18n).
 */
export function moduleDescription(summary: IModuleSummary | undefined, lang: Lang): string {
  if (!summary) return '';
  const strings = createModuleStrings(summary.key, lang, () => moduleBundle(lang, summary.key));
  const main = summary.recordTypes.find((r) => r.main) ?? summary.recordTypes[0];
  return (main ? strings.entity(main.key, 'description', null) : '') || strings.tagline(summary.tagline ?? null);
}
